var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    [
      _c(
        "v-card-title",
        { staticStyle: { height: "55px" } },
        [
          _vm._v("\n        Review Rental Rates\n        "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: { icon: "" },
              on: {
                click: function ($event) {
                  return _vm.$emit("modal-close")
                },
              },
            },
            [_c("v-icon", [_vm._v("mdi-close")])],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "p-2",
          staticStyle: { height: "calc( 90vh - 55px)", "overflow-y": "auto" },
        },
        [
          _c("v-alert", { attrs: { text: "", color: "info" } }, [
            _c("div", [
              _vm._v(
                "This page lists all our prices, to select one you need to create new or edit existing renter on\n                current page.\n            "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("v-simple-table", {
            staticClass: "table-rental-rates bordered",
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function () {
                  return [
                    _c("thead", [
                      _c(
                        "tr",
                        [
                          _c("th", { staticClass: "text-left" }, [
                            _c("div", [_vm._v("EQUIPMENT PACKAGE")]),
                          ]),
                          _vm._v(" "),
                          _vm.config.module_type_enabled != 0 &&
                          _vm.config.module_type == "module_14"
                            ? [
                                _c(
                                  "th",
                                  {
                                    staticClass: "text-left",
                                    style: _vm.priceThStyle,
                                  },
                                  [
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$store.state.model.reservation
                                            .is_seasonal
                                            ? "Seasonal rate"
                                            : "1 Day"
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-left",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            2-3 Days\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c("th", { style: _vm.priceThStyle }, [
                                      _vm._v(
                                        "\n                            4+ Days\n                        "
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            : _vm.$store.state.model.reservation.is_delivery
                            ? [
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c("th", { style: _vm.priceThStyle }, [
                                      _vm._v(
                                        "\n                            Delivery\n                        "
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            : _vm.config.module_type_enabled != 0 &&
                              _vm.config.module_type == "module_11"
                            ? [
                                _c(
                                  "th",
                                  {
                                    staticClass: "text-left",
                                    style: _vm.priceThStyle,
                                  },
                                  [
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$store.state.model.reservation
                                            .is_seasonal
                                            ? "Seasonal rate"
                                            : "1st Day Rate"
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            2nd Day Rate\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            3rd Day Rate\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            Additional Day Rate\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            : _vm.frontend_view_folder == "frontend.plaines"
                            ? [
                                _c(
                                  "th",
                                  {
                                    staticClass: "text-left",
                                    style: _vm.priceThStyle,
                                  },
                                  [
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$store.state.model.reservation
                                            .is_seasonal
                                            ? "Seasonal rate"
                                            : "Daily rate"
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            Multi day rate\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            Weekly rate\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            : _vm.frontend_view_folder ==
                              "frontend.mtshastasports"
                            ? [
                                _c(
                                  "th",
                                  {
                                    staticClass: "text-left",
                                    style: _vm.priceThStyle,
                                  },
                                  [
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$store.state.model.reservation
                                            .is_seasonal
                                            ? "Seasonal rate"
                                            : "1 Day Rate"
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            2 Day Rate\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            3+ Day Rate\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            : _vm.config.module_type_enabled != 0 &&
                              _vm.config.module_type == "module_16"
                            ? [
                                _c(
                                  "th",
                                  {
                                    staticClass: "text-left",
                                    style: _vm.priceThStyle,
                                  },
                                  [
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$store.state.model.reservation
                                            .is_seasonal
                                            ? "Seasonal rate"
                                            : "1 Day Rate"
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            2 Day\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            3-4 Day\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            5+ Days\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            : _vm.frontend_view_folder ==
                              "frontend.nmsportsystems"
                            ? [
                                _c(
                                  "th",
                                  {
                                    staticClass: "text-left",
                                    style: _vm.priceThStyle,
                                  },
                                  [
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$store.state.model.reservation
                                            .is_seasonal
                                            ? "Seasonal rate"
                                            : "1 to 2 Day"
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            3 to 4 Day\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                           5 to 6 Day\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            7+ Days\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            : _vm.frontend_view_folder == "frontend.skigd"
                            ? [
                                _c(
                                  "th",
                                  {
                                    staticClass: "text-left",
                                    style: _vm.priceThStyle,
                                  },
                                  [
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$store.state.model.reservation
                                            .is_seasonal
                                            ? "Seasonal rate"
                                            : "Daily Rate"
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.$store.state.model.reservation
                                  .single_day_type == "afternoon"
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            Afternoon\n                        "
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                           Night\n                        "
                                        ),
                                      ]
                                    ),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            Multi day rates\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            : _vm.config.module_type_enabled != 0 &&
                              _vm.config.module_type == "module_17"
                            ? [
                                _c(
                                  "th",
                                  {
                                    staticClass: "text-left",
                                    style: _vm.priceThStyle,
                                  },
                                  [
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$store.state.model.reservation
                                            .is_seasonal
                                            ? "Seasonal rate"
                                            : "Daily Rate"
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.$store.state.model.reservation
                                  .single_day_type == "afternoon"
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            Afternoon\n                        "
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                           Night\n                        "
                                        ),
                                      ]
                                    ),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            Multi day rates\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            : _vm.frontend_view_folder == "frontend.basin" ||
                              (_vm.config.module_type_enabled != 0 &&
                                (_vm.config.module_type == "module_5" ||
                                  _vm.config.module_type == "module_8"))
                            ? [
                                _c(
                                  "th",
                                  {
                                    staticClass: "text-left",
                                    style: _vm.priceThStyle,
                                  },
                                  [
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$store.state.model.reservation
                                            .is_seasonal
                                            ? "Seasonal rate"
                                            : "1 Day Rate"
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            2 Day Rate\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            3 Day Rate\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            4 Day Rate\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            5 Day Rate\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            6 Day Rate\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation
                                  .is_seasonal && _vm.showSevenDayRate
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            7 Day Rate\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation
                                  .is_seasonal &&
                                _vm.showSevenDayRate &&
                                _vm.frontend_view_folder ==
                                  "frontend.winterpark"
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            8 Day Rate\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation
                                  .is_seasonal &&
                                _vm.showSevenDayRate &&
                                _vm.frontend_view_folder ==
                                  "frontend.winterpark"
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            9 Day Rate\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation
                                  .is_seasonal &&
                                _vm.config.module_type_enabled != 0 &&
                                _vm.config.module_type !== "module_8"
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            Additional Day Rate\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            : _vm.config.module_type_enabled != 0 &&
                              _vm.config.module_type == "module_5_1"
                            ? [
                                _c(
                                  "th",
                                  {
                                    staticClass: "text-left",
                                    style: _vm.priceThStyle,
                                  },
                                  [
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$store.state.model.reservation
                                            .is_seasonal
                                            ? "Seasonal rate"
                                            : "1 Day Rate"
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            2 Day Rate\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            3 Day Rate\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            Additional Day Rate\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            : _vm.config.module_type_enabled != 0 &&
                              _vm.config.module_type == "module_5_1"
                            ? [
                                _c(
                                  "th",
                                  {
                                    staticClass: "text-left",
                                    style: _vm.priceThStyle,
                                  },
                                  [
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$store.state.model.reservation
                                            .is_seasonal
                                            ? "Seasonal rate"
                                            : "1 Day Rate"
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            2 Day Rate\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            3 Day Rate\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            4 Day Rate\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            5 Day Rate\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            6 Day Rate\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            7 Day Rate\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            Additional Day Rate\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            : _vm.config.module_type_enabled != 0 &&
                              _vm.config.module_type == "module_5_2"
                            ? [
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            1/2 Day Rate\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "th",
                                  {
                                    staticClass: "text-left",
                                    style: _vm.priceThStyle,
                                  },
                                  [
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$store.state.model.reservation
                                            .is_seasonal
                                            ? "Seasonal rate"
                                            : "1 Day Rate"
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            2 Day Rate\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            3 Day Rate\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            4 Day Rate\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            5 Day Rate\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            6 Day Rate\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation
                                  .is_seasonal && _vm.showSevenDayRate
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            7 Day Rate\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation
                                  .is_seasonal &&
                                _vm.config.module_type_enabled != 0 &&
                                _vm.config.module_type !== "module_8"
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            Additional Day Rate\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            : _vm.config.module_type_enabled != 0 &&
                              _vm.config.module_type == "module_5_3"
                            ? [
                                _c(
                                  "th",
                                  {
                                    staticClass: "text-left",
                                    style: _vm.priceThStyle,
                                  },
                                  [
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$store.state.model.reservation
                                            .is_seasonal
                                            ? "Seasonal rate"
                                            : "Daily rate"
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.multi_day_is_enabled &&
                                !_vm.$store.state.model.reservation
                                  .is_seasonal &&
                                !_vm.$store.state.model.reservation.is_prepay ==
                                  "1"
                                  ? _c("th", { style: _vm.priceThStyle }, [
                                      _c("div", [
                                        _vm._v(_vm._s(_vm.multi_day_title)),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.config.discount > 0 &&
                                !_vm.$store.state.model.reservation.is_prepay ==
                                  "1" &&
                                !_vm.$store.state.model.reservation
                                  .is_seasonal &&
                                _vm.$store.state.model.reservation._type !=
                                  "kiosk"
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-left",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _c("div", [
                                          _vm._v(
                                            "Online Rate (" +
                                              _vm._s(_vm.config.discount) +
                                              "% Discount)"
                                          ),
                                        ]),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            1/2 Day Rate\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            : _vm.frontend_view_folder ==
                                "frontend.rootsrentals" ||
                              _vm.frontend_view_folder == "frontend.stowe" ||
                              (_vm.config.module_type_enabled != 0 &&
                                _vm.config.module_type == "module_4")
                            ? [
                                _c(
                                  "th",
                                  {
                                    staticClass: "text-left",
                                    style: _vm.priceThStyle,
                                  },
                                  [
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$store.state.model.reservation
                                            .is_seasonal
                                            ? "Seasonal rate"
                                            : "1 Day Rate"
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            2 Day Rate\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            3 Day Rate\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            4 Day Rate\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            5 Day Rate\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            Additional Day Rate\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            : _vm.config.module_type_enabled &&
                              _vm.config.module_type == "module_9"
                            ? [
                                _c(
                                  "th",
                                  {
                                    staticClass: "text-left",
                                    style: _vm.priceThStyle,
                                  },
                                  [
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$store.state.model.reservation
                                            .is_seasonal
                                            ? "Seasonal rate"
                                            : "1 Day Rate"
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                           Day 2 to 3 rate\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                           Day 4+ rate\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation
                                  .is_seasonal &&
                                _vm.$store.state.model.reservation._type ==
                                  "kiosk"
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            1/2 Day rate\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            Night rate\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            : _vm.config.module_type_enabled &&
                              _vm.config.module_type == "module_10"
                            ? [
                                _c(
                                  "th",
                                  {
                                    staticClass: "text-left",
                                    style: _vm.priceThStyle,
                                  },
                                  [
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$store.state.model.reservation
                                            .is_seasonal
                                            ? "Seasonal rate"
                                            : "1 Day Rate"
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                           Day 2 rate\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            Additional day rate\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            : _vm.frontend_view_folder == "frontend.gallatin" ||
                              _vm.frontend_view_folder == "frontend.tygart" ||
                              (_vm.config.module_type_enabled != 0 &&
                                _vm.config.module_type == "module_3")
                            ? [
                                _c(
                                  "th",
                                  {
                                    staticClass: "text-left",
                                    style: _vm.priceThStyle,
                                  },
                                  [
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$store.state.model.reservation
                                            .is_seasonal
                                            ? "Seasonal rate"
                                            : "Day 1 to 2 rate"
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c("th", { style: _vm.priceThStyle }, [
                                      _vm._v(
                                        "\n                            Day 3 to 4 rate\n                        "
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c("th", { style: _vm.priceThStyle }, [
                                      _vm._v(
                                        "\n                           Day 5 + rate\n                        "
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            : _vm.frontend_view_folder == "frontend.ridesnow"
                            ? [
                                _c(
                                  "th",
                                  {
                                    staticClass: "text-left",
                                    style: _vm.priceThStyle,
                                  },
                                  [
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$store.state.model.reservation
                                            .is_seasonal
                                            ? "Seasonal rate"
                                            : "Mid-Week Rate (M-TH)"
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c("th", { style: _vm.priceThStyle }, [
                                      _vm._v(
                                        "\n                           Weekend / Holiday Rate\n                        "
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            : _vm.config.module_type_enabled != 0 &&
                              (_vm.config.module_type == "module_6" ||
                                _vm.config.module_type == "module_18")
                            ? [
                                _c(
                                  "th",
                                  {
                                    staticClass: "text-left",
                                    style: _vm.priceThStyle,
                                  },
                                  [
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$store.state.model.reservation
                                            .is_seasonal
                                            ? "Seasonal rate"
                                            : "Mid-Week Rate (M-TH)"
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c("th", { style: _vm.priceThStyle }, [
                                      _vm._v(
                                        "\n                           Weekend / Holiday Rate\n                        "
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c("th", { style: _vm.priceThStyle }, [
                                      _vm._v(
                                        "\n                           Night Skiing\n                        "
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            : _vm.config.module_type_enabled &&
                              _vm.config.module_type == "module_13"
                            ? [
                                _c(
                                  "th",
                                  {
                                    staticClass: "text-left",
                                    style: _vm.priceThStyle,
                                  },
                                  [
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$store.state.model.reservation
                                            .is_seasonal
                                            ? "Seasonal rate"
                                            : "Day 1 to 2 rate"
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c("th", { style: _vm.priceThStyle }, [
                                      _vm._v(
                                        "\n                            Day 2 to 5 rate\n                        "
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c("th", { style: _vm.priceThStyle }, [
                                      _vm._v(
                                        "\n                          Day 6+ rate\n                        "
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            : _vm.config.module_type_enabled != 0 &&
                              _vm.config.module_type == "module_19"
                            ? [
                                _c(
                                  "th",
                                  {
                                    staticClass: "text-left",
                                    style: _vm.priceThStyle,
                                  },
                                  [
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$store.state.model.reservation
                                            .is_seasonal
                                            ? "Seasonal rate"
                                            : "Daily Rate"
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            4 Day Rate\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.$store.state.model.reservation.is_seasonal
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            Weekly Rate\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            : [
                                _c(
                                  "th",
                                  {
                                    staticClass: "text-left",
                                    style: _vm.priceThStyle,
                                  },
                                  [
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$store.state.model.reservation
                                            .is_seasonal
                                            ? "Seasonal rate"
                                            : "Daily rate"
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.multi_day_is_enabled &&
                                !_vm.$store.state.model.reservation
                                  .is_seasonal &&
                                !_vm.$store.state.model.reservation.is_prepay ==
                                  "1"
                                  ? _c("th", { style: _vm.priceThStyle }, [
                                      _c("div", [
                                        _vm._v(_vm._s(_vm.multi_day_title)),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.config.discount > 0 &&
                                !_vm.$store.state.model.reservation.is_prepay ==
                                  "1" &&
                                !_vm.$store.state.model.reservation
                                  .is_seasonal &&
                                _vm.$store.state.model.reservation._type !=
                                  "kiosk"
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "text-left",
                                        style: _vm.priceThStyle,
                                      },
                                      [
                                        _c("div", [
                                          _vm._v(
                                            "Online Rate (" +
                                              _vm._s(_vm.config.discount) +
                                              "% Discount)"
                                          ),
                                        ]),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                        ],
                        2
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      [
                        _vm._l(_vm.packages_list_data, function (group) {
                          return [
                            group.title !== "Group reservations" ||
                            (group.title === "Group reservations" &&
                              _vm.config.group_reservation == 1)
                              ? [
                                  _c("tr", [
                                    _c(
                                      "td",
                                      { attrs: { colspan: _vm.colspan } },
                                      [_c("h4", [_vm._v(_vm._s(group.title))])]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(group.items, function (item) {
                                    return _c(
                                      "tr",
                                      [
                                        _c(
                                          "td",
                                          [
                                            item.description
                                              ? _c(
                                                  "v-expansion-panels",
                                                  {
                                                    attrs: {
                                                      flat: "",
                                                      tile: "",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-expansion-panel",
                                                      {
                                                        staticStyle: {
                                                          background:
                                                            "transparent",
                                                        },
                                                        attrs: { expand: "" },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .packagesExpansion[
                                                              item.id
                                                            ],
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.packagesExpansion,
                                                              item.id,
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "packagesExpansion[item.id]",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-expansion-panel-header",
                                                          [
                                                            _vm._v(
                                                              "\n                                            " +
                                                                _vm._s(
                                                                  item.title
                                                                ) +
                                                                "\n                                        "
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-expansion-panel-content",
                                                          {
                                                            attrs: {
                                                              ripple: "",
                                                            },
                                                          },
                                                          [
                                                            _c("div", {
                                                              domProps: {
                                                                innerHTML:
                                                                  _vm._s(
                                                                    item.description
                                                                  ),
                                                              },
                                                            }),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _c("span", [
                                                  _vm._v(_vm._s(item.title)),
                                                ]),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _vm.config.module_type_enabled != 0 &&
                                        _vm.config.module_type == "module_14"
                                          ? [
                                              _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.current_rate)
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.day2_rate)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.day_4_plus)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          : _vm.$store.state.model.reservation
                                              .is_delivery
                                          ? [
                                              _c(
                                                "td",
                                                { staticClass: "text-center" },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.current_rate)
                                                  ),
                                                ]
                                              ),
                                            ]
                                          : _vm.config.module_type_enabled !=
                                              0 &&
                                            _vm.config.module_type ==
                                              "module_11"
                                          ? [
                                              _c(
                                                "td",
                                                { staticClass: "text-center" },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.current_rate)
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.day_2_rate)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.day_3_rate)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.additional_day_rate
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          : _vm.frontend_view_folder ==
                                            "frontend.plaines"
                                          ? [
                                              _c(
                                                "td",
                                                { staticClass: "text-center" },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.current_rate)
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.multi_day_rate
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.day_7_rate)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          : _vm.frontend_view_folder ==
                                            "frontend.mtshastasports"
                                          ? [
                                              _c(
                                                "td",
                                                { staticClass: "text-center" },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.current_rate)
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.day_2_rate)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.day_3_rate)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          : _vm.config.module_type_enabled !=
                                              0 &&
                                            _vm.config.module_type ==
                                              "module_16"
                                          ? [
                                              _c(
                                                "td",
                                                { staticClass: "text-center" },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.current_rate)
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.day2_rate)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.day3_4_rate)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.day_5_rate)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          : _vm.frontend_view_folder ==
                                              "frontend.basin" ||
                                            (_vm.config.module_type_enabled !=
                                              0 &&
                                              (_vm.config.module_type ==
                                                "module_5" ||
                                                _vm.config.module_type ==
                                                  "module_8"))
                                          ? [
                                              _c(
                                                "td",
                                                { staticClass: "text-center" },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.current_rate)
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.day_2_rate)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.day_3_rate)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.day_4_rate)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.day_5_rate)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.day_6_rate)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal &&
                                              _vm.showSevenDayRate
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.day_7_rate)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal &&
                                              _vm.showSevenDayRate &&
                                              _vm.frontend_view_folder ==
                                                "frontend.winterpark"
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.day_8_rate)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal &&
                                              _vm.showSevenDayRate &&
                                              _vm.frontend_view_folder ==
                                                "frontend.winterpark"
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.day_9_rate)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal &&
                                              _vm.config.module_type_enabled !=
                                                0 &&
                                              _vm.config.module_type !==
                                                "module_8"
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.additional_day_rate
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          : _vm.config.module_type_enabled !=
                                              0 &&
                                            _vm.config.module_type ==
                                              "module_5_1"
                                          ? [
                                              _c(
                                                "td",
                                                { staticClass: "text-center" },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.current_rate)
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.day_2_rate)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.day_3_rate)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.additional_day_rate
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          : _vm.config.module_type_enabled !=
                                              0 &&
                                            _vm.config.module_type ==
                                              "module_5_2"
                                          ? [
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.half_day_rate
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-center" },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.current_rate)
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.day_2_rate)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.day_3_rate)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.day_4_rate)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.day_5_rate)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.day_6_rate)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal &&
                                              _vm.showSevenDayRate
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.day_7_rate)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal &&
                                              _vm.config.module_type_enabled !=
                                                0 &&
                                              _vm.config.module_type !==
                                                "module_8"
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.additional_day_rate
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          : _vm.config.module_type_enabled !=
                                              0 &&
                                            _vm.config.module_type ==
                                              "module_5_3"
                                          ? [
                                              _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.daily_rate)
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.multi_day_is_enabled &&
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal &&
                                              !_vm.$store.state.model
                                                .reservation.is_prepay == "1"
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.multi_day_rate
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.config.discount > 0 &&
                                              !_vm.$store.state.model
                                                .reservation.is_prepay == "1" &&
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal &&
                                              _vm.$store.state.model.reservation
                                                ._type != "kiosk"
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.online_rate)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.half_day_rate
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          : _vm.frontend_view_folder ==
                                              "frontend.rootsrentals" ||
                                            _vm.frontend_view_folder ==
                                              "frontend.stowe" ||
                                            (_vm.config.module_type_enabled !=
                                              0 &&
                                              _vm.config.module_type ==
                                                "module_4")
                                          ? [
                                              _c(
                                                "td",
                                                { staticClass: "text-center" },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.current_rate)
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.day_2_rate)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.day_3_rate)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.day_4_rate)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.day_5_rate)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.additional_day_rate
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          : _vm.frontend_view_folder ==
                                            "frontend.nmsportsystems"
                                          ? [
                                              _c(
                                                "td",
                                                { staticClass: "text-center" },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.current_rate)
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.day3_4_rate)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.day5_6_rate)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.day_7_plus)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          : _vm.frontend_view_folder ==
                                            "frontend.skigd"
                                          ? [
                                              _c(
                                                "td",
                                                { staticClass: "text-center" },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.current_rate)
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.$store.state.model.reservation
                                                .single_day_type == "afternoon"
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.half_day_rate
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.night_rate)
                                                      ),
                                                    ]
                                                  ),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.multi_day_rate
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          : _vm.config.module_type_enabled !=
                                              0 &&
                                            _vm.config.module_type ==
                                              "module_17"
                                          ? [
                                              _c(
                                                "td",
                                                { staticClass: "text-center" },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.current_rate)
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.$store.state.model.reservation
                                                .single_day_type == "afternoon"
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.half_day_rate
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.night_rate)
                                                      ),
                                                    ]
                                                  ),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.multi_day_rate
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          : _vm.config.module_type_enabled &&
                                            _vm.config.module_type == "module_9"
                                          ? [
                                              _c(
                                                "td",
                                                { staticClass: "text-center" },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.current_rate)
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.day2_rate)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.day_4_plus)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal &&
                                              _vm.$store.state.model.reservation
                                                ._type == "kiosk"
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.half_day_rate
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.night_rate)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          : _vm.config.module_type_enabled &&
                                            _vm.config.module_type ==
                                              "module_10"
                                          ? [
                                              _c(
                                                "td",
                                                { staticClass: "text-center" },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.current_rate)
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.day2_rate)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.additional_day_rate
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          : _vm.frontend_view_folder ==
                                              "frontend.gallatin" ||
                                            _vm.frontend_view_folder ==
                                              "frontend.tygart" ||
                                            (_vm.config.module_type_enabled !=
                                              0 &&
                                              _vm.config.module_type ==
                                                "module_3")
                                          ? [
                                              _c(
                                                "td",
                                                { staticClass: "text-center" },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.current_rate)
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.day3_4_rate)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.day_4_plus)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          : _vm.frontend_view_folder ==
                                            "frontend.ridesnow"
                                          ? [
                                              _c(
                                                "td",
                                                { staticClass: "text-center" },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.current_rate)
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.holiday_rate
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          : _vm.config.module_type_enabled !=
                                              0 &&
                                            (_vm.config.module_type ==
                                              "module_6" ||
                                              _vm.config.module_type ==
                                                "module_18")
                                          ? [
                                              _c(
                                                "td",
                                                { staticClass: "text-center" },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.current_rate)
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.holiday_rate
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.night_rate)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          : _vm.config.module_type_enabled &&
                                            _vm.config.module_type ==
                                              "module_13"
                                          ? [
                                              _c(
                                                "td",
                                                { staticClass: "text-center" },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.current_rate)
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.day2_5)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.day_6_plus)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          : _vm.config.module_type_enabled !=
                                              0 &&
                                            _vm.config.module_type ==
                                              "module_19"
                                          ? [
                                              _c(
                                                "td",
                                                { staticClass: "text-center" },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.current_rate)
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.day_4_rate)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.week_rate)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          : [
                                              _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.daily_rate)
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.multi_day_is_enabled &&
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal &&
                                              !_vm.$store.state.model
                                                .reservation.is_prepay == "1"
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.multi_day_rate
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.config.discount > 0 &&
                                              !_vm.$store.state.model
                                                .reservation.is_prepay == "1" &&
                                              !_vm.$store.state.model
                                                .reservation.is_seasonal &&
                                              _vm.$store.state.model.reservation
                                                ._type != "kiosk"
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.online_rate)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                      ],
                                      2
                                    )
                                  }),
                                ]
                              : _vm._e(),
                          ]
                        }),
                      ],
                      2
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }